<app-table [data]="toolRequests"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [headerBackgroundColor]="headerBackgroundColor"
           [rowExpand]="false"
           [saveFilters]="true"
           [hasTitle]="hasTitle"
           [isMaterial]="false"
           title="{{'atom.tool-requests-lines.table.title' | translate}}"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)">
    <app-table-column header="{{'atom.tool-requests-lines.table.columns.createdAt' | translate}}"
                      filterPlaceholder="{{'atom.tool-requests-lines.table.filters.byCreatedTime' | translate}}"
                      field="name">
        <ng-template #body
                     let-toolRequest="rowData">
            <span>{{ toolRequest.createdDate }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'atom.tool-requests-lines.table.columns.line' | translate}}"
                      filterPlaceholder="{{'atom.tool-requests-lines.table.filters.byLine' | translate}}"
                      filter="true"
                      field="line"
                      [sortable]="false">
        <ng-template #body
                     let-toolRequest="rowData">
            <span>{{ toolRequest.line?.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'atom.tool-requests-lines.table.columns.partNumber' | translate}}"
                      filterPlaceholder="{{'atom.tool-requests-lines.table.filters.byPartNumber' | translate}}"
                      filter="true"
                      field="partNumber"
                      [sortable]="false">
        <ng-template #body
                     let-toolRequest="rowData">
            <span>{{ toolRequest.partNumber?.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'atom.tool-requests-lines.table.columns.type' | translate}}"
                      field="type"
                      [sortable]="false">
        <ng-template #body let-toolRequest="rowData">
            <span>    {{ 'atom.tool-requests-lines.table.type.' + toolRequest.type | translate }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'atom.tool-requests-lines.table.columns.status' | translate}}"
                      filterPlaceholder="{{'atom.tool-requests-lines.table.filters.byStatus' | translate}}"
                      [sortable]="false"
                      field="status">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="statusFilters"
                          valueField="value"
                          displayField="name"
                          emptyText="{{'atom.tool-requests-lines.table.columns.status' | translate}}"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body
                     let-tool="rowData">
            <span>{{ tool.status | translate }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column cls="last-column"
                      header="{{'atom.tool-requests-lines.table.columns.actions' | translate}}">
        <ng-template #body
                     let-toolRequest="rowData">
            <app-button *ngIf="shouldRenderProcess(toolRequest)"
                        type="primary"
                        class="process-button"
                        (clicked)="process(toolRequest)">
                {{ 'generic.buttons.process' | translate }}
            </app-button>
            <app-button *ngIf="shouldRenderResume(toolRequest)" type="warning"
                        class="process-button"
                        (clicked)="resume(toolRequest)">
                {{ 'generic.buttons.resume' | translate }}
            </app-button>
            <app-tooltip *ngIf="toolRequest.highPriority" type="info"
                         record="{{'atom.tool-returns.table.columns.orderedPriority' | translate}}">
            </app-tooltip>
        </ng-template>
    </app-table-column>
</app-table>
